import { GridIcon } from "@radix-ui/react-icons";
import { Button, Tooltip } from "@radix-ui/themes";
import { useEditorStore } from "../../stores";

export function StageTools() {
  const { showGrid, setShowGrid } = useEditorStore();

  return (
    <div className="stage-tools">
      <Tooltip content={showGrid ? "Hide Grid (G)" : "Show Grid (G)"}>
        <Button
          variant="soft"
          radius="none"
          size="2"
          onClick={() => setShowGrid(!showGrid)}
          className={showGrid ? "active" : ""}
        >
          <GridIcon />
        </Button>
      </Tooltip>
    </div>
  );
}
